export const slumpTypeToNumber = (slump_orderd: any) => {
  let slump_data = slump_orderd.match(/SF\d+|F\d+|\d+/g)?.[0] || "";

  let slump;

  // slump_data = "F4";
  if (slump_data && slump_data.includes("F")) {
    switch (slump_data) {
      case "F1":
        slump = 170;
        break;
      case "F2":
        slump = 200;
        break;
      case "F3":
        slump = 220;
        break;
      case "F4":
        slump = 250;
        break;
      case "F5":
        slump = 250;
        break;
      case "F6":
        slump = 250;
        break;
      case "SF1":
        slump = 250;
        break;
      case "SF2":
        slump = 250;
        break;
      case "SF3":
        slump = 250;
        break;
      default:
        slump = "Unknown"; // Default case for unrecognized types
        break;
    }
  } else {
    // Ensure `input` is a valid number before multiplying
    slump = (Number(slump_data) || 0) * 25;
  }

  return slump;
};
